var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.384,
    height: 40,
    viewBox: "0 0 39.384 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "school-svgrepo-com",
    transform: "translate(-3.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1.231,
    height: 19.076,
    transform: "translate(5.171 19.076)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 39.384,
    height: 1.231,
    transform: "translate(3.94 38.769)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 18.461,
    height: 1.231,
    transform: "translate(14.402 8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 18.461,
    height: 1.231,
    transform: "translate(14.402 6.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M15.632,96.247h1.231V67.939H15.632v5.538H6.4V69.17H12.32l-1.538-3.077,1.539-3.077H5.171V73.478H3.94v1.231H15.632v.615H3.94v1.231H15.632Zm-9.231-32h3.927l-.923,1.846.923,1.846H6.4Z",
    transform: "translate(0 -58.093)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 1.231,
    height: 3.077,
    transform: "translate(8.248 19.692)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 1.231,
    height: 3.077,
    transform: "translate(12.555 19.692)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 1.231,
    height: 3.077,
    transform: "translate(8.248 24.615)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 1.231,
    height: 3.077,
    transform: "translate(12.555 24.615)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 1.231,
    height: 3.077,
    transform: "translate(8.248 29.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 1.231,
    height: 3.077,
    transform: "translate(12.555 29.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 1.231,
    height: 3.077,
    transform: "translate(8.248 34.461)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 1.231,
    height: 3.077,
    transform: "translate(12.555 34.461)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 1.231,
    height: 19.076,
    transform: "translate(40.863 19.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M355.57,74.708V73.478h-1.231V63.016h-7.15l1.539,3.077L347.19,69.17h5.919v4.308h-9.231V67.939h-1.231V96.246h1.231V76.554H355.57V75.324H343.878v-.615H355.57Zm-6.389-6.769.923-1.846-.923-1.846h3.927v3.692Z",
    transform: "translate(-312.246 -58.093)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 1.231,
    height: 3.077,
    transform: "translate(37.786 19.692)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 1.231,
    height: 3.077,
    transform: "translate(33.478 19.692)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 1.231,
    height: 3.077,
    transform: "translate(37.786 24.615)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 1.231,
    height: 3.077,
    transform: "translate(33.478 24.615)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 1.231,
    height: 3.077,
    transform: "translate(37.786 29.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 1.231,
    height: 3.077,
    transform: "translate(33.478 29.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 1.231,
    height: 3.077,
    transform: "translate(37.786 34.461)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 1.231,
    height: 3.077,
    transform: "translate(33.478 34.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M209.478,379.446v-9.231h-8.615v9.231h1.231v-8h2.461v8h1.231v-8h2.461v8Z",
    transform: "translate(-181.538 -341.292)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 1.231,
    height: 1.231,
    transform: "translate(24.863 35.077)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 1.231,
    height: 1.231,
    transform: "translate(21.17 35.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M190.032,141.785h-4.923v16h4.923ZM188.8,156.554H186.34v-2.461H188.8Zm0-3.692H186.34V150.4H188.8Zm0-3.692H186.34v-2.461H188.8Zm0-3.692H186.34v-2.462H188.8Z",
    transform: "translate(-167.015 -130.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M268.8,141.785h-4.923v16H268.8Zm-1.231,14.769h-2.461v-2.461h2.461Zm0-3.692h-2.461V150.4h2.461Zm0-3.692h-2.461v-2.461h2.461Zm0-3.692h-2.461v-2.462h2.461Z",
    transform: "translate(-239.63 -130.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M216.125,4.308h-3.077V0h-1.231V4.308H208.74V5.538h7.385Z",
    transform: "translate(-188.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoi);
export default __webpack_public_path__ + "static/media/goi.b53e142e811266e75f38e73876fca66e.svg";
export { ForwardRef as ReactComponent };